// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"61":"ArticlesView","182":"AuthorsView","200":"TopicsView","899":"ArticleDetailView","909":"SponsorsView"}[chunkId] || chunkId) + "-legacy." + {"61":"8a397169","182":"127277b9","200":"118de73f","499":"b198c61c","706":"2fe16d50","899":"f94d7963","909":"7e49407e"}[chunkId] + ".js";
};